(() => {
  const form = document.querySelector('[data-ls-predictive-form]');
  if (!form || form.dataset.ready === 'true') return;
  form.dataset.ready = 'true';

  const input = form.querySelector('[data-ls-predictive-input]');
  const results = form.querySelector('[data-ls-predictive-results]');
  if (!input || !results) return;

  let timer;
  let controller;
  const money = new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
    maximumFractionDigits: 0,
  });

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;',
  })[character]);

  const close = () => {
    results.hidden = true;
    input.setAttribute('aria-expanded', 'false');
  };

  const open = (markup) => {
    results.innerHTML = markup;
    results.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  };

  const renderProduct = (product) => {
    const image = product.featured_image?.url || product.image || '';
    const price = Number(product.price || 0);
    const sizedImage = image ? `${image}${image.includes('?') ? '&' : '?'}width=116` : '';
    return `<a href="${escapeHtml(product.url)}" role="option">
      ${image ? `<img src="${escapeHtml(sizedImage)}" width="58" height="58" alt="" loading="lazy">` : '<span></span>'}
      <span><b>${escapeHtml(product.title)}</b><small>${product.available === false ? 'Agotado' : 'Disponible · Envío gratis'}</small></span>
      <strong>${money.format(price)}</strong>
    </a>`;
  };

  const search = async () => {
    const query = input.value.trim();
    if (query.length < 2) return close();
    controller?.abort();
    controller = new AbortController();
    open('<p>Buscando productos…</p>');
    try {
      const endpoint = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last`;
      const response = await fetch(endpoint, { signal: controller.signal, headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('predictive-search');
      const data = await response.json();
      const products = data.resources?.results?.products || [];
      if (!products.length) {
        open(`<p>No encontramos productos para “${escapeHtml(query)}”.</p>`);
        return;
      }
      open(`${products.map(renderProduct).join('')}<footer><span>${products.length} sugerencias</span><a href="/search?q=${encodeURIComponent(query)}&type=product">Ver todos los resultados →</a></footer>`);
    } catch (error) {
      if (error.name !== 'AbortError') close();
    }
  };

  input.addEventListener('input', () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(search, 220);
  });
  input.addEventListener('focus', () => {
    if (input.value.trim().length >= 2) search();
  });
  input.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });
  document.addEventListener('click', (event) => {
    if (!form.contains(event.target)) close();
  });
})();
